import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 20px;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid ${props => props.theme.colors.greyL};
`;

export const IconCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.theme.colors.greyXXXL};
  border: 2px solid ${props => props.bg || props.theme.colors.grey};
  color: ${props => props.theme.colors.greyXXD};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 15px;
`;

export const HeaderText = styled.div`
  flex: 1;
`;

export const Title = styled.h2`
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.textSecondary};
`;

export const SectionTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
`;

export const Field = styled.div`
  margin-bottom: 12px;
`;

export const Label = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: 4px;
`;

export const Value = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  line-height: 1.4;
  white-space: pre-wrap;
`;
